import {Component} from "@angular/core";
import {AditivoService} from 'src/app/services/aditivo.service';
import {Aditivo} from 'src/app/model/Aditivo';
import {Router} from "@angular/router";
import {PesquisaAditivoStateService} from "src/app/services/pesquisa-aditivo.state.service";

@Component({
  selector: 'pesquisa-interna-aditivo',
  templateUrl: './pesquisa-interna-aditivo.component.html',
  styleUrls: ['./pesquisa-interna-aditivo.component.scss',],
  standalone: false
})
export class PesquisaInternaAditivoComponent {
  exibePesquisaAvancada: boolean;
  aditivos: Aditivo[];
  msg: string;

  // Critério básico
  criterio: string;
  // Critérios Avançados
  instituicaoFinanceira: string;
  criterioDatProtocoloInicio: Date;
  criterioDatProtocoloFim: Date;
  criterioSituacao: string;
  criterioFase: string;
  criterioProposta: string;
  criterioAno: number;
  criterioPac: string;
  criterioComprador: string;


  constructor(
    private service: AditivoService,
    private router: Router,
    private state: PesquisaAditivoStateService,
  ) {
  }

  ngOnInit(): void {
    this.msg = "Faça uma pesquisa acima";
    //this.pesquisar();

    this.state.state$.subscribe(
      s => {
        this.exibePesquisaAvancada = s.exibePesquisaAvancada;
        this.aditivos = [...s.aditivos];
        this.criterio = s.criterio;
        this.instituicaoFinanceira = s.instituicaoFinanceira;
        this.criterioDatProtocoloInicio = s.criterioDatProtocoloInicio;
        this.criterioDatProtocoloFim = s.criterioDatProtocoloFim;
        this.criterioSituacao = s.criterioSituacao;
        this.criterioFase = s.criterioFase;
        this.criterioProposta = s.criterioProposta;
        this.criterioAno = s.criterioAno;
        this.criterioPac = s.criterioPac;
        this.criterioComprador = s.criterioComprador;

        this.msg = this.aditivos?.length ? null : "Faça uma pesquisa acima";
      })
  }

  pesquisar() {
    if (this.criterioSituacao == "null") {
      this.criterioSituacao = null;
    }
    if (this.criterioFase == "null") {
      this.criterioFase = null;
    }
    this.msg = "...";
    if (this.exibePesquisaAvancada) {
      this.service.pesquisaAditivoInternaAvancada( //
        this.instituicaoFinanceira,
        this.criterioDatProtocoloInicio,
        this.criterioDatProtocoloFim,
        this.criterioSituacao,
        this.criterioFase,
        this.criterioProposta,
        this.criterioAno,
        this.criterioPac,
        this.criterioComprador
      ).subscribe(c => {
        this.aditivos = c.list;
        this.msg = null;
        this.state.update({
          exibePesquisaAvancada: this.exibePesquisaAvancada,
          aditivos: this.aditivos,
          instituicaoFinanceira: this.instituicaoFinanceira,
          criterioDatProtocoloInicio: this.criterioDatProtocoloInicio,
          criterioDatProtocoloFim: this.criterioDatProtocoloFim,
          criterioSituacao: this.criterioSituacao,
          criterioFase: this.criterioFase,
          criterioProposta: this.criterioProposta,
          criterioAno: this.criterioAno,
          criterioPac: this.criterioPac,
          criterioComprador: this.criterioComprador
        });
      });
    } else {
      this.service.pesquisaAditivoInterna(this.criterio).subscribe(c => {
        this.aditivos = c.list;
        this.msg = null;
        this.state.update({
          exibePesquisaAvancada: this.exibePesquisaAvancada,
          criterio: this.criterio,
          aditivos: this.aditivos,
        });
      });
    }
  }

  alternarPesquisa() {
    this.exibePesquisaAvancada = !this.exibePesquisaAvancada;
  }

  onVisualizarClick(aditivo: Aditivo) {
    this.router.navigate(["/analisa-aditivo/" + aditivo.id]);
  }
}
